module.exports = __webpack_public_path__ + "static/img/grac-oidd-competition-pt.f4c31aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/grac-oidd-competition-pt.jpg
// module id = HYFi
// module chunks = 0